import React from "react";
import Footer from "../Layout/Footer";
import Header from "../Layout/Header";
import Crumb from "../utils/Crumb";
import About1 from "../../images/about_1.jpg";
import About2 from "../../images/about_2.jpg";
import {Bounce, Slide} from "react-reveal";

import "./about.css";

// * CARD.........

const AboutCard = ({heading,text}) => {
  return (
    <div className="row icon_about">
      <div className="col-lg-3 col-md-4 col-sm-12 col-12 pr-0">
        <div className="icon_container shadow">
          <svg
            width="2.6rem"
            viewBox="0 0 384 384"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m164 244 124-124 80 80v136c0 17.679688-14.320312 32-32 32h-288c-17.679688 0-32-14.320312-32-32v-48l96-96zm0 0"
              style={{ fill: `#fff` }}
            />
            <path
              d="m368 48v152l-80-80-124 124-52-52-96 96v-240c0-17.679688 14.320312-32 32-32h288c17.679688 0 32 14.320312 32 32zm-256 48c0-8.800781-7.199219-16-16-16s-16 7.199219-16 16 7.199219 16 16 16 16-7.199219 16-16zm0 0"
              style={{ fill: `var(--color-light)` }}
            />
            <g style={{ fill: `var(--color-light)` }}>
              <path d="m336 0h-288c-26.472656 0-48 21.527344-48 48v288c0 26.472656 21.527344 48 48 48h288c26.472656 0 48-21.527344 48-48v-288c0-26.472656-21.527344-48-48-48zm-288 32h288c8.824219 0 16 7.175781 16 16v113.375l-52.6875-52.6875c-6.25-6.246094-16.375-6.246094-22.625 0l-112.6875 112.6875-40.6875-40.6875c-6.25-6.246094-16.375-6.246094-22.625 0l-68.6875 68.6875v-201.375c0-8.824219 7.175781-16 16-16zm288 320h-288c-8.824219 0-16-7.175781-16-16v-41.375l80-80 92.6875 92.679688c3.128906 3.136718 7.214844 4.695312 11.3125 4.695312s8.183594-1.558594 11.3125-4.6875c6.246094-6.25 6.246094-16.375 0-22.625l-40.6875-40.6875 101.375-101.367188 64 64v129.367188c0 8.824219-7.175781 16-16 16zm0 0" />
            </g>
          </svg>
        </div>
      </div>
      <div className="col-lg-9 col-md-8 col-sm-12 col-12 pl-0 d-flex align-items-center">
        <div className="">
          <h5>{heading}</h5>
          <p className="mb-0 font-smaller">
            {text}
          </p>
        </div>
      </div>
    </div>
  );
};


// !MAIN SECTION

const About = () => {
  return (
    <div>
      <Header />
      <Crumb title="About Us" slogan="Lorem Ipsum Dollar Sir Met" />
      <section className="py-5 about_section">
        <div className="container">
          <div className="row">
            <Slide left>
            <div className="col-lg-6 pt-5 pb-4 px-4 d-flex justify-content-center align-items-center">
              <div className="">
                <h1 className="font-weight-bold p-3">Our Mission</h1>
                <h5 className="p-3">
                  To help patients connect to doctor seamlessly
                </h5>
                <br />
                <div className="col-lg-6 pt-5 pb-4 hide_on_large">
                  <img
                    src={About1}
                    className="w-100 shadow-lg"
                    alt="DOCTERIO"
                  />
                </div>
                <p className="p-3">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Est,
                  tenetur sit! Molestias, atque? Officiis alias ducimus vel ipsa
                  consequatur nobis quos rem magnam esse sapiente maiores
                  voluptas, unde ipsam nisi.
                </p>
              </div>
            </div>
            </Slide>
            <Slide right>
            <div className="col-lg-6 pt-5 pb-4 hide_on_med">
              <img src={About1} className="w-100 shadow-lg" alt="DOCTERIO" />
            </div>
            </Slide>
          </div>
        </div>
      </section>
      <section className="py-5 about_section">
        <div className="container">
          <div className="row">
            <Slide left>
            <div className="col-lg-6 pt-4 pb-5 hide_on_med">
              <img src={About2} className="w-100 shadow-lg" alt="DOCTERIO" />
            </div>
            </Slide>
            <Slide right>
            <div className="col-lg-6 px-4 pt-4 pb-5 d-flex justify-content-center align-items-center">
              <div>
                <h1 className="font-weight-bold p-3">About Docterio</h1>
                <div className="col-lg-6 pt-5 pb-4 hide_on_large">
                  <img
                    src={About2}
                    className="w-100 shadow-lg"
                    alt="DOCTERIO"
                  />
                </div>
                <p className="p-3">
                  Docterio is the mission to digitalize the health care system
                  in Bangladesh. The user friendly platform will help patients
                  confirm their appointments with their preffered doctor
                  seamlessly. No more hassle waiting in long lines or phone
                  calls to book appointments because Docterio got you covered.
                </p>
              </div>
            </div>
            </Slide>
          </div>
        </div>
      </section>
      <section className="list_your_experiance text-white about_section p-4">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 d-flex justify-content-center align-items-center">
              <div className="py-5">
                <h1 style={{ fontSize: `3rem`, fontWeight: `600` }}>
                  Why choose Docterio?
                </h1>
                <p className="mb-4">
                  Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ex
                  eius consequuntur incidunt omnis.
                </p>
                <button className="btn btn-outline-light text-capitalize px-4">
                  search your doctor now
                </button>
              </div>
            </div>
            <div className="col-lg-2"></div>
            <div className="col-lg-6">
              <div className="inner_icons px-4 py-5">
                <Bounce cascade right delay={100}>
                <div className="container-fluid">
                  <div className="mb-4">
                    <AboutCard heading="Lem ipsum dolor sit amet" text="Lorem, ipsum dolor sit amet consectetur adipisicing elit"/>
                  </div>
                  <div className="py-3">
                    <AboutCard heading="Loem ipsum dolor sit amet" text="Lorem, ipsum dolor sit amet consectetur adipisicing elit,consectetur adipisicing elit,consectetur."/>
                  </div>
                  <div className="line"></div>
                  <div className="py-3">
                    <AboutCard heading="Loem ipsum dolor sit amet" text="Lorem, ipsum dolor sit amet consectetur adipisicing elit,consectetur adipisicing elit,consectetur."/>
                  </div>
                  <div className="line"></div>
                  <div className="py-3">
                    <AboutCard heading="Loem ipsum dolor sit amet" text="Lorem, ipsum dolor sit amet consectetur adipisicing elit,consectetur adipisicing elit,consectetur."/>
                  </div>
                  <div className="line"></div>
                </div>
                </Bounce>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default About;
